import React from 'react'

const Badge = (props) => {

  return (
    <span className={'rounded-md border py-1 px-2 text-gray-800 mx-2 ' + (props.color ? ('border-'+props.color+'-500 bg-'+props.color+'-50') : 'border-lime-500 bg-lime-50')}>
      <i className={'bi bi-'+props.icon+' me-1 ' + (props.color ? ('text-'+props.color+'-500') : 'text-lime-500')}></i>{props.text}
    </span>
  )
}

export default Badge